export const ACCOUNT_KEY = 'ACCOUNT_KEY'
export const MERCHANT_ACCOUNT_KEY = 'MERCHANT_ACCOUNT_KEY'
export const MERCHANT_MENU_KEY = 'MERCHANT_MENU_KEY'
export const MENU_CATEGORY_KEY = 'MENU_CATEGORY_KEY'
export const MENU_ITEMS_KEY = 'MENU_ITEMS_KEY'
export const MERCHANT_ITEMS_KEY = 'MERCHANT_ITEMS_KEY'
export const REVENUE_CENTERS = 'REVENUE_CENTERS'
export const ORDER_HISTORY_KEY = 'ORDER_HISTORY_KEY'
export const ORDER_STATUS_KEY = 'ORDER_STATUS_KEY'